/* unplugin-vue-components disabled */import script from "./navTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./navTabs.vue?vue&type=script&setup=true&lang=js"

import "./navTabs.vue?vue&type=style&index=0&id=1fad010b&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fad010b"]])

export default __exports__